function initForXH(){

  // IE support
  if (window.ActiveXObject && !window.XMLHttpRequest) {
    window.XMLHttpRequest = function() {
      var msxmls = new Array(
        'Msxml2.XMLHTTP.5.0',
        'Msxml2.XMLHTTP.4.0',
        'Msxml2.XMLHTTP.3.0',
        'Msxml2.XMLHTTP',
        'Microsoft.XMLHTTP');
      for (var i = 0; i < msxmls.length; i++) {
        try {
          return new ActiveXObject(msxmls[i]);
        } catch (e) {
        }
      }
      return null;
    };
  }
  // Gecko support
  /* ;-) */
  // Opera support
  if (window.opera && !window.XMLHttpRequest) {
    window.XMLHttpRequest = function() {
      this.readyState = 0; // 0=uninitialized,1=loading,2=loaded,3=interactive,4=complete
      this.status = 0; // HTTP status codes
      this.statusText = '';
      this._headers = [];
      this._aborted = false;
      this._async = true;
      this._defaultCharset = 'ISO-8859-1';
      this._getCharset = function() {
        var charset = _defaultCharset;
        var contentType = this.getResponseHeader('Content-type').toUpperCase();
        val = contentType.indexOf('CHARSET=');
        if (val != -1) {
          charset = contentType.substring(val);
        }
        val = charset.indexOf(';');
        if (val != -1) {
          charset = charset.substring(0, val);
        }
        val = charset.indexOf(',');
        if (val != -1) {
          charset = charset.substring(0, val);
        }
        return charset;
      };
      this.abort = function() {
        this._aborted = true;
      };
      this.getAllResponseHeaders = function() {
        return this.getAllResponseHeader('*');
      };
      this.getAllResponseHeader = function(header) {
        var ret = '';
        for (var i = 0; i < this._headers.length; i++) {
          if (header == '*' || this._headers[i].h == header) {
            ret += this._headers[i].h + ': ' + this._headers[i].v + '\n';
          }
        }
        return ret;
      };
      this.getResponseHeader = function(header) {
        var ret = getAllResponseHeader(header);
        var i = ret.indexOf('\n');
        if (i != -1) {
          ret = ret.substring(0, i);
        }
        return ret;
      };
      this.setRequestHeader = function(header, value) {
        this._headers[this._headers.length] = {h:header, v:value};
      };
      this.open = function(method, url, async, user, password) {
        this.method = method;
        this.url = url;
        this._async = true;
        this._aborted = false;
        this._headers = [];
        if (arguments.length >= 3) {
          this._async = async;
        }
        if (arguments.length > 3) {
          opera.postError('XMLHttpRequest.open() - user/password not supported');
        }
        this.readyState = 1;
        if (this.onreadystatechange) {
          this.onreadystatechange();
        }
      };
      this.send = function(data) {
        if (!navigator.javaEnabled()) {
          alert("XMLHttpRequest.send() - Java must be installed and enabled.");
          return;
        }
        if (this._async) {
          setTimeout(this._sendasync, 0, this, data);
          // this is not really asynchronous and won't execute until the current
          // execution context ends
        } else {
          this._sendsync(data);
        }
      }
      this._sendasync = function(req, data) {
        if (!req._aborted) {
          req._sendsync(data);
        }
      };
      this._sendsync = function(data) {
        this.readyState = 2;
        if (this.onreadystatechange) {
          this.onreadystatechange();
        }
        // open connection
        var url = new java.net.URL(new java.net.URL(window.location.href), this.url);
        var conn = url.openConnection();
        for (var i = 0; i < this._headers.length; i++) {
          conn.setRequestProperty(this._headers[i].h, this._headers[i].v);
        }
        this._headers = [];
        if (this.method == 'POST') {
          // POST data
          conn.setDoOutput(true);
          var wr = new java.io.OutputStreamWriter(conn.getOutputStream(), this._getCharset());
          wr.write(data);
          wr.flush();
          wr.close();
        }
        // read response headers
        // NOTE: the getHeaderField() methods always return nulls for me :(
        var gotContentEncoding = false;
        var gotContentLength = false;
        var gotContentType = false;
        var gotDate = false;
        var gotExpiration = false;
        var gotLastModified = false;
        for (var i = 0; ; i++) {
          var hdrName = conn.getHeaderFieldKey(i);
          var hdrValue = conn.getHeaderField(i);
          if (hdrName == null && hdrValue == null) {
            break;
          }
          if (hdrName != null) {
            this._headers[this._headers.length] = {h:hdrName, v:hdrValue};
            switch (hdrName.toLowerCase()) {
              case 'content-encoding': gotContentEncoding = true; break;
              case 'content-length'  : gotContentLength   = true; break;
              case 'content-type'    : gotContentType     = true; break;
              case 'date'            : gotDate            = true; break;
              case 'expires'         : gotExpiration      = true; break;
              case 'last-modified'   : gotLastModified    = true; break;
            }
          }
        }
        // try to fill in any missing header information
        var val;
        val = conn.getContentEncoding();
        if (val != null && !gotContentEncoding) this._headers[this._headers.length] = {h:'Content-encoding', v:val};
        val = conn.getContentLength();
        if (val != -1 && !gotContentLength) this._headers[this._headers.length] = {h:'Content-length', v:val};
        val = conn.getContentType();
        if (val != null && !gotContentType) this._headers[this._headers.length] = {h:'Content-type', v:val};
        val = conn.getDate();
        if (val != 0 && !gotDate) this._headers[this._headers.length] = {h:'Date', v:(new Date(val)).toUTCString()};
        val = conn.getExpiration();
        if (val != 0 && !gotExpiration) this._headers[this._headers.length] = {h:'Expires', v:(new Date(val)).toUTCString()};
        val = conn.getLastModified();
        if (val != 0 && !gotLastModified) this._headers[this._headers.length] = {h:'Last-modified', v:(new Date(val)).toUTCString()};
        // read response data
        var reqdata = '';
        var stream = conn.getInputStream();
        if (stream) {
          var reader = new java.io.BufferedReader(new java.io.InputStreamReader(stream, this._getCharset()));
          var line;
          while ((line = reader.readLine()) != null) {
            if (this.readyState == 2) {
              this.readyState = 3;
              if (this.onreadystatechange) {
                this.onreadystatechange();
              }
            }
            reqdata += line + '\n';
          }
          reader.close();
          this.status = 200;
          this.statusText = 'OK';
          this.responseText = reqdata;
          this.readyState = 4;
          if (this.onreadystatechange) {
            this.onreadystatechange();
          }
          if (this.onload) {
            this.onload();
          }
        } else {
          // error
          this.status = 404;
          this.statusText = 'Not Found';
          this.responseText = '';
          this.readyState = 4;
          if (this.onreadystatechange) {
            this.onreadystatechange();
          }
          if (this.onerror) {
            this.onerror();
          }
        }
      };
    };
  }
  // ActiveXObject emulation
  if (!window.ActiveXObject && window.XMLHttpRequest) {
    window.ActiveXObject = function(type) {
      switch (type.toLowerCase()) {
        case 'microsoft.xmlhttp':
        case 'msxml2.xmlhttp':
        case 'msxml2.xmlhttp.3.0':
        case 'msxml2.xmlhttp.4.0':
        case 'msxml2.xmlhttp.5.0':
          return new XMLHttpRequest();
      }
      return null;
    };
  }
  setupDone = true;
}


function getDataXH(url, actionHandler, errorHandler, identifier,mode) {
  initForXH();
  var req = new XMLHttpRequest(); 
  //alert("---" + req.status);
  if(req) {
    // My first closure.. yippie!!
    req.onreadystatechange = function () {
      // only if req shows "loaded"
      if (req.readyState == 4) {
        //alert("oucchhh"+req.status);
        //if (typeof(req.status)== "undefined")
        //  return;
        // only if "OK"
        if (req.status == 200) {
          //enableClicks();
          if (typeof(identifier)== "undefined") 
            eval(actionHandler+"(req.responseText)");
          else  if (typeof(identifier)== "string") 
            eval(actionHandler+"(req.responseText, identifier)");
          else  
            eval(actionHandler+"(req.responseText, identifier )");            
        } else {
          _handleError(errorHandler);
        }
      }
    }
   // alert("might send");
   if(mode=='sync')
   	 req.open("GET", url, false);   	 
   else
    req.open("GET", url, true);
    req.send(null);
   // alert("sent!!");
  } else {
   // alert("elserrrr");
    _handleError(errorHandler);
  }
}

//-----------------------------------------------------------------------------------

function getDataIF(_url, actionHandler, errorHandler, identifier) {
  var IFrameObj; // our IFrame object
  if (!document.createElement) {
    return false;
  }
  //Safari
  if (navigator.userAgent.indexOf('Safari') !=-1){
    return false;
  }
  var IFrameDoc;
  var URL = _url;
  if (!IFrameObj && document.createElement) {
    // create the IFrame and assign a reference to the
    // object to our global variable IFrameObj.
    // this will only happen the first time 
    // getDataIF() is called
   try {
      var tempIFrame=document.createElement('iframe');
      tempIFrame.setAttribute('id','RSIFrame');
      tempIFrame.style.border='0px';
      tempIFrame.style.width='0px';
      tempIFrame.style.height='0px';
      tempIFrame.src = "/html/pbbook/IEFrameWarningBypass.html"; 
      IFrameObj = document.body.appendChild(tempIFrame);
      
      if (document.frames) {
        // this is for IE5 Mac, because it will only
        // allow access to the document object
        // of the IFrame if we access it through
        // the document.frames array
        IFrameObj = document.frames['RSIFrame'];
      }
    } catch(exception) {
      // This is for IE5 PC, which does not allow dynamic creation
      // and manipulation of an iframe object. Instead, we'll fake
      // it up by creating our own objects.
      iframeHTML='\<iframe id="RSIFrame" style="';
      iframeHTML+='border:0px;';
      iframeHTML+='width:0px;';
      iframeHTML+='height:0px;';
      iframeHTML+=' SRC=\"/html/pbbook/IEFrameWarningBypass.html\" '

      iframeHTML+='"><\/iframe>';
      document.body.innerHTML+=iframeHTML;
      IFrameObj = new Object();
      IFrameObj.document = new Object();
      IFrameObj.document.location = new Object();
      IFrameObj.document.location.iframe = document.getElementById('RSIFrame');
      IFrameObj.document.location.replace = function(location) {
        this.iframe.src = location;
      }
    }
  }
  
  if (IFrameObj.contentDocument) {
    // For NS6
    IFrameDoc = IFrameObj.contentDocument; 
  } else if (IFrameObj.contentWindow) {
    // For IE5.5 and IE6
    IFrameDoc = IFrameObj.contentWindow.document;
  } else if (IFrameObj.document) {
    // For IE5
    IFrameDoc = IFrameObj.document;
  } else {
    return false;
  }
  
  IFrameDoc.location.replace(URL);
  iFrameSuccessCallback = function(data){
     //enableClicks();
     if (typeof(identifier)== "undefined") 
       eval(actionHandler+"(data)");
     else  if (typeof(identifier)== "string") 
       eval(actionHandler+"(data, identifier)");
     else  
       eval(actionHandler+"(data, identifier)");
  }
  iFrameErrorCallback = function(){
    _handleError(errorHandler);
  }
  return true;
}


function _handleError(errorHandler){
//enableClicks();
  if (errorHandler==null)
    alert("There was a problem retrieving some data.");
  else 
    eval(errorHandler+"()");
}

//-----------------------------------------------------------------------------------

function getData(_url, actionHandler, errorHandler, identifier,mode) {
 // alert("xyz");
  //var iFrameSupported = getDataIF(setHandlerType(_url,"iFrame"), actionHandler, errorHandler, identifier)
  //if(!iFrameSupported ){
    getDataXH(setHandlerType(_url,"xmlHttp"), actionHandler, errorHandler, identifier,mode)
  //}
}

function setHandlerType(_url, typeStr){
  var typeParam="_rpcClientType=" + typeStr+"&r="+Math.floor(Math.random()*100000);
  var index=_url.lastIndexOf('/')+1;
  var last =_url.substring(index);
  var lastIndex = last.indexOf('?')
  if (lastIndex==-1){
    _url+='?';
    lastIndex=last.length-1;
  }
  if ((lastIndex >0) && !((last.length)==(lastIndex+1)))
    _url = _url + '&' + typeParam;
  else
    _url = _url + typeParam;
  return _url;
}

function submitForm(target, form, actionHandler, errorHandler, identifier) {
  getData(target+ buildQueryString(form), actionHandler, errorHandler, identifier)
  
}

function buildQueryString(theForm) {
  //theForm = document.forms[theFormName];
  var qs = ''
  for (e=0;e<theForm.elements.length;e++) {
    if (theForm.elements[e].name!='') {
      qs+=(qs=='')?'?':'&'
      qs+=theForm.elements[e].name+'='+escape(theForm.elements[e].value)
      }
    }
  return qs;
}


//--------------------------------------------------------------------------------------

function replaceElement(elementName, data){
  var element = document.getElementById(elementName);
  element.innerHTML = data;
}

function insertAtStart(elementName, data){
  var element = document.getElementById(elementName);
  var inner = element.innerHTML;
  element.innerHTML = data+inner;
}

function insertAtEnd(elementName, data){
  var element = document.getElementById(elementName);
  var inner = element.innerHTML;
  element.innerHTML = inner+data;
}

//--------------------------------------------------------------------------------------
